import { UtilsService } from 'src/app/core/services/utils.service';
import { ApiService } from './api.service';
import { DataService } from 'src/app/core/services/data.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SessionExpiredModalComponent } from 'src/app/shared/components/session-expired-modal/session-expired-modal.component';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public logout$ = new Subject<void>();
  private sessionExpiredDialogOpen = false;

  constructor(
    private router: Router,
    private dataService: DataService,
    private apiService: ApiService,
    private utilsService: UtilsService,
    private store: Store,
    private dialog: MatDialog) { }

  logOut() {
    localStorage.clear();
    this.logout$.next();
    this.router.navigate(['/auth/login']);
  }

  // Da usare solo per il 401 "sessione scaduta" (interceptor), non per il logout volontario:
  // avvisa l'utente con un countdown prima di reindirizzarlo al login.
  sessionExpired() {
    localStorage.clear();
    this.logout$.next();
    if (this.sessionExpiredDialogOpen) {
      return;
    }
    this.sessionExpiredDialogOpen = true;
    this.dialog.open(SessionExpiredModalComponent, {
      width: '500px',
      position: { top: '40px' },
      disableClose: true
    }).afterClosed().subscribe(() => {
      this.sessionExpiredDialogOpen = false;
      this.router.navigate(['/auth/login']);
    });
  }


  isAuthenticated() {
    let token = localStorage.getItem("token");
    return token != null;
  }

  isFeatureGranted(functionalityName, level) {
    level = level.toLowerCase();
    var feature;
    let user = this.dataService.getCurrentUserInfo();
    // console.log('ZAK - isFeatureGranted - user:', user);
    if (this.isAuthenticated() && !_.isEmpty(user) && !_.isEmpty(user.user) && !_.isEmpty(user.user.group) && !_.isEmpty(user.user.group.features)) {
      for (var i = 0; i < user.user.group.features.length; ++i) {
        feature = user.user.group.features[i];
        for (var k = 0; k < feature.functionalities.length; ++k) {
          if (feature.functionalities[k].name === functionalityName) {
            // funzi. trovata.
            if (level === 'write' && feature.functionalities[k].settings.manage) {
              // vero che ha "write"
              return true;
            }
            if (level === 'read' && feature.functionalities[k].settings.enabled) {
              // vero che ha "read"
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  // Check if user has write grant on provided menu label name
  isMenuLabelWriteGranted(menuLabelName) {
    let user = this.dataService.getCurrentUser();
    var menuItem = this.utilsService.getMenuItem(user.menu, menuLabelName);
    if (menuItem !== undefined) {
      return menuItem.w;
    } else {
      return false;
    }
  }

  // Check if user has read grant on provided menu label name
  isMenuLabelReadGranted(menuLabelName) {
    let user = this.dataService.getCurrentUser();
    var menuItem = this.utilsService.getMenuItem(user.menu, menuLabelName);
    if (menuItem !== undefined) {
      return true;
    } else {
      return false;
    }
  }
}
